//import DataSender from "./DataSender";
import {
  Formik,
  Field,
  Form,
  ErrorMessage,
  FieldArray,
  useFormik,
  useFormikContext,
} from "formik";
import { BlobProvider, pdf, usePDF } from "@react-pdf/renderer";
import { useState } from "react";
import { Button } from "@mui/material";
import * as yup from "yup";
import { loginRequest } from "../../authConfig";
import {
  callBackend,
  callMsGraphSiteDriveId,
  callMsGraphSiteId,
  callGraphCreateListItem,
  callMsGraphImageUUID,
  createImageFolder,
  uploadImage,
} from "../../graph";
import { useMsal } from "@azure/msal-react";
import initialValues from "../../JSON/initialValues.json";
import HashLoader from "react-spinners/HashLoader";
import { Camera, CameraResultType } from "@capacitor/camera";
import { DateTime } from "luxon";
import { v4 as uuid } from "uuid";
import { isAndroid } from "react-device-detect";
import PropTypes from "prop-types";
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const TestForm = ({
  siteData,
  meData,
  androidAccessToken,
  seniorManager,
  siteManager,
}) => {
  const projectSelectData = [];

  siteData.map((site, index) => {
    projectSelectData[index] = site.fields;
  });

  projectSelectData.sort((a, b) => {
    const aKey = a.Title.slice(0, 4);
    const bKey = b.Title.slice(0, 4);
    return aKey.localeCompare(bKey);
  });

  const filtered = projectSelectData.filter(
    (item) => item.Title !== "Maxi Construction Hub" && item.isActive == true
  );

  console.log(filtered);

  const projectOptions = [];

  const [options, SetOptions] = useState(siteData);
  const [projectData, setProjectData] = useState({});
  const { instance, accounts } = useMsal();
  const [siteId, setSiteId] = useState("");
  const [siteDriveId, setSiteDriveId] = useState("");
  const [uploadPdf, setUploadPdf] = useState();
  let documentUUID = null;
  sessionStorage.setItem("documentUUID", "null");
  sessionStorage.setItem("documentUUIDSet", "false");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  console.log("is Senior Manager?: " + seniorManager);
  console.log("is Site Manager?: " + siteManager);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  async function setUUID() {
    while (
      sessionStorage.getItem("documentUUID") == "null" &&
      sessionStorage.getItem("documentUUIDSet") == "false"
    ) {
      if (!isAndroid) {
        let responseStatus;
        const tempUUID = uuid();

        //let responseStatus
        const token = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        responseStatus = await callMsGraphImageUUID(
          token.accessToken,
          tempUUID
        );

        if (responseStatus === 404) {
          sessionStorage.setItem("documentUUID", tempUUID);
          sessionStorage.setItem("documentUUIDSet", true);
          createImageFolder(
            token.accessToken,
            sessionStorage.getItem("documentUUID")
          );
        } else {
          return;
        }
      } else {
        let responseStatus;
        const tempUUID = uuid();

        //let responseStatus

        responseStatus = await callMsGraphImageUUID(
          androidAccessToken,
          tempUUID
        );

        if (responseStatus === 404) {
          sessionStorage.setItem("documentUUID", tempUUID);
          sessionStorage.setItem("documentUUIDSet", true);
          createImageFolder(
            androidAccessToken,
            sessionStorage.getItem("documentUUID")
          );
        } else {
          return;
        }
      }
    }
  }

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };

  async function takePicture(field, question, { setFieldValue }, index) {
    const image = await Camera.getPhoto({
      quality: 100,
      allowEditing: true,
      resultType: CameraResultType.Uri,
    });

    // Here you get the image as result.
    const theActualPicture = image.webPath;
    const response = await fetch(theActualPicture);

    const blob = await response.blob();

    const fr = new FileReader();
    fr.readAsText(blob);

    const file = new File([blob], question + ".png", {
      type: "image/png",
      lastModified: new Date(),
    });

    const fileName = question + ".png";
    const img = document.getElementById("img" + index);
    img.src = theActualPicture;
    // setFieldValue passed into function from formik
    setFieldValue(field, file);
    if (!isAndroid) {
      if (sessionStorage.getItem("documentUUIDSet") == "false") {
        await setUUID();
        const token = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const imageDownloadUrl = await uploadImage(
          token.accessToken,
          sessionStorage.getItem("documentUUID"),
          blob,
          fileName
        );

        setFieldValue(field, imageDownloadUrl["@microsoft.graph.downloadUrl"]);
      } else {
        const token = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const imageDownloadUrl = await uploadImage(
          token.accessToken,
          sessionStorage.getItem("documentUUID"),
          blob,
          fileName
        );

        setFieldValue(field, imageDownloadUrl["@microsoft.graph.downloadUrl"]);
      }
    } else {
      if (sessionStorage.getItem("documentUUIDSet") == "false") {
        await setUUID();
        const imageDownloadUrl = await uploadImage(
          androidAccessToken,
          sessionStorage.getItem("documentUUID"),
          blob,
          fileName
        );

        setFieldValue(field, imageDownloadUrl["@microsoft.graph.downloadUrl"]);
      } else {
        const imageDownloadUrl = await uploadImage(
          androidAccessToken,
          sessionStorage.getItem("documentUUID"),
          blob,
          fileName
        );

        setFieldValue(field, imageDownloadUrl["@microsoft.graph.downloadUrl"]);
      }
    }
  }

  async function getSiteId(body) {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    let projectSlugArray = body.formData.project.split(",");
    let projectSlug = projectSlugArray[1];

    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraphSiteId(response.accessToken, projectSlug).then(
          (response) => {
            console.log(response);
            getSiteDriveId(response.id, body);
          }
        );
      });
  }

  async function getSiteDriveId(siteId, body) {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraphSiteDriveId(response.accessToken, siteId).then(
          (response) => {
            passDataToBackend(siteId, response.value[1].id, body);
          }
        );
      });
  }

  async function passDataToBackend(siteId, driveId, body) {
    body.siteId = siteId;
    body.driveId = driveId;
    body.seniorManager = seniorManager;
    body.siteManager = siteManager;


      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          body.accessToken = response.accessToken;
          callBackend(body)
        });
   
  }

  async function createListItem(body) {
    if (!isAndroid) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          body.accessToken = response.accessToken;
          callGraphCreateListItem(body);
        });
    }
  }

  return (
    <>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Your Form has been submitted!
            </Typography>
            <div className="my-2">
              <button
                onClick={handleClose}
                className="mx-auto bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      </div>
      {siteData ? (
        <Formik
          initialValues={initialValues}
          validationSchema={yup.object().shape({
            initialValues: yup.object().shape({
              questions: yup.array().of(
                yup.object().shape({
                  action: yup.string().required("Field is required!"),
                  comment: yup.string().when("action", (action) => {
                    if (action == "Action" || action == "Comment") {
                      return yup.string().required("Comment Required");
                    } else {
                      return yup.string();
                    }
                  }),
                })
              ),
            }),
          })}
          onSubmit={async (values, { resetForm }) => {
            let projectSlugArray = values.initialValues.project.split(",");
            const id = uuid();
            const shortId = id.substring(0, 8);
            const fileName =
              shortId +
              "-SMSIR-" +
              projectSlugArray[0] +
              "-Week " +
              DateTime.now().weekNumber +
              "-" +
              DateTime.now().year +
              ".pdf";

            const body = {};
            body.formData = values.initialValues;
            body.fileName = fileName;
            body.date = DateTime.now();
            body.name = meData;
            body.imgFolder = sessionStorage.getItem("documentUUID");
            body.seniorManager = seniorManager;
            body.siteManager = siteManager;

            getSiteId(body);
            createListItem(body);
            callBackend(body);
            handleOpen();
            resetForm();
          }}
        >
          {({ values, isSubmitting, setFieldValue }) => (
            <>
              <Form>
                {siteData ? (
                  <div className="p-4">
                    <label htmlFor={`initialValues.project`} className="block">
                      <span className="text-gray-700">Project</span>
                    </label>
                    <Field
                      name="initialValues.project"
                      as="select"
                      className="block p-2 w-full mt-1 rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                    >
                      <option value="" label="" hidden>
                        Select an option
                      </option>
                      {filtered.map((value) => {
                        let project = value.webUrl.Url;
                        let projectArray = project.split("/");
                        let projectSlugId =
                          projectArray[projectArray.length - 1];
                        return (
                          <option
                            key={value.Title}
                            value={value.Title + "," + projectSlugId}
                          >
                            {value.Title}
                          </option>
                        );
                      })}
                    </Field>
                  </div>
                ) : (
                  ""
                )}
                <ErrorMessage name={`initialValues.project`} />
                <FieldArray
                  name="questions"
                  render={() => (
                    <div>
                      {values.initialValues.questions &&
                      values.initialValues.questions.length > 0
                        ? values.initialValues.questions.map(
                            (question, index) => (
                              <div
                                key={index}
                                className="p-4 m-4 grid gap-2 border-red-300 border-2 rounded-lg"
                              >
                                <label
                                  htmlFor={`questions.${index}.action`}
                                  className="block"
                                >
                                  <span className="text-gray-700">
                                    {question.name}
                                  </span>
                                  <Field
                                    name={`initialValues.questions.${index}.action`}
                                    as="select"
                                    className="block p-2 w-full mt-1 rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                  >
                                    <option value="" label="" hidden>
                                      Select an option
                                    </option>
                                    <option value="Action">Action</option>
                                    <option value="Inspected">Inspected</option>
                                    <option value="Not Inspected">
                                      Not Inspected
                                    </option>
                                    <option value="Not Applicable">
                                      Not Applicable
                                    </option>
                                    <option value="Comment">Comment</option>
                                  </Field>
                                  <ErrorMessage
                                    name={`initialValues.questions.${index}.action`}
                                    className="text-red-500 text-xl mt-2 text-center"
                                    component="div"
                                  />
                                </label>
                                <label className="block mt-4">
                                  <span className="text-gray-700 mt-2">
                                    Image (Optional)
                                  </span>
                                </label>
                                <Button
                                  id={`initialValues.questions.${index}.file`}
                                  variant="contained"
                                  onClick={(e) =>
                                    takePicture(
                                      e.target.id,
                                      question.name,
                                      { setFieldValue },
                                      index
                                    )
                                  }
                                >
                                  Take a Photo
                                </Button>
                                <img
                                  className={
                                    question.file ? "mx-auto" : "hidden"
                                  }
                                  id={"img" + index}
                                />

                                {question.action === "Action" ||
                                question.action === "Comment" ? (
                                  <>
                                    <Field
                                      as="textarea"
                                      className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                      name={`initialValues.questions.${index}.comment`}
                                      placeholder="Comment"
                                      rows={3}
                                    />
                                    <ErrorMessage
                                      name={`initialValues.questions.${index}.comment`}
                                      className="text-red-500 text-xl mt-2 text-center"
                                      component="div"
                                    />
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            )
                          )
                        : ""}
                      <button
                        className={
                          isSubmitting
                            ? "bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded opacity-35"
                            : "bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded"
                        }
                      >
                        Submit
                      </button>
                    </div>
                  )}
                />
              </Form>
            </>
          )}
        </Formik>
      ) : (
        <div className="mx-auto mt-4">
          <HashLoader
            className="mx-auto mr-8"
            color="rgb(239 68 68)"
            cssOverride={override}
            size={100}
          />
        </div>
      )}
    </>
  );
};

// RIGHT:
TestForm.propTypes = {
  siteData: PropTypes.array,
  meData: PropTypes.string,
};

export default TestForm;
